import {indexedActionTypes} from "../../reducers/indexedReducer";

export const ADD_STATE = (path) => ({
    type: indexedActionTypes.ADD_STATE,
    payload: {
        path: path,
        data: { /* initial data */ } }
});

export const REMOVE_STATE = (path) => ({
    type: indexedActionTypes.REMOVE_STATE,
    payload: path
});

export const setViewMode = (path, viewMode = 'LIST') => ({
    type : indexedActionTypes.view,
    path,
    payload : viewMode
});

export const setLoading = (path, data) => ({
    type : indexedActionTypes.loading,
    path,
    payload : data
});

export const setUdn = (path, data) => ({
    type : indexedActionTypes.udn,
    path,
    payload: data
});

export const setModule = (path, data) => ({
    type : indexedActionTypes.module,
    path,
    payload: data
});

export const setMenu = (path, data) => ({
    type : indexedActionTypes.menu,
    path,
    payload: data
});

export const setApp = (path, data) => ({
    type : indexedActionTypes.app,
    path,
    payload: data
});

export const setCategory = (path, data) => ({
    type : indexedActionTypes.category,
    path,
    payload: data
});

export const setParent = (path, data) => ({
    type : indexedActionTypes.parent,
    path,
    payload: data
});

export const setMapConfig = (path, data) => ({
    type : indexedActionTypes.mapConfig,
    path,
    payload: data
});

export const setUserIsAdmin = (path, data) => ({
    type : indexedActionTypes.userIsAdmin,
    path,
    payload: data
});

export const setItems = (path, data) => ({
    type: indexedActionTypes.listDomainObjects,
    path,
    payload: data
});

export const setFilter = (path, data) => ({
    type: indexedActionTypes.filter,
    path,
    payload: data
});

export const setTableParams = (path, pageSize= 10, pageIndex= 0, totalSize= 0, currentPage =1) => ({
    type : indexedActionTypes.tableParams,
    path,
    payload: { pageSize, pageIndex, totalSize, currentPage }
});

export const removeItem = (path, data) => ({
    type : indexedActionTypes.removeItem,
    path,
    payload: data
});

export const addItem = (path, data) => ({
    type : indexedActionTypes.addItem,
    path,
    payload: data
});

export const addAllItems = (path, data) => ({
    type : indexedActionTypes.addAllItems,
    path,
    payload: data
});

export const changeListItem = (path, data) => ({
    type : indexedActionTypes.changeItem,
    path,
    payload: data
});

export const changeAllItems = (path, data) => ({
    type : indexedActionTypes.changeAllItems,
    path,
    payload: data
});

export const setForm = (path, editMode = false, disableInputs = false, saveSuccess = false) => ({
    type : indexedActionTypes.formData,
    path,
    payload: { editMode, disableInputs, saveSuccess }
});

export const setItem = (path, data) => ({
    type : indexedActionTypes.domainObject,
    path,
    payload : data
});

